module.exports = __webpack_public_path__ + "media/images/lb/587-1e0c25663b91c8225d3ed99e95a2081a.svg";